<template>
  <div class="product-container pt-5 position-relative vw-100">
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterModal"
        v-on:enter="actions.enterModal"
        v-on:leave="actions.leaveModal"
    >

      <div class="product-instructions">
        <LocalizedLink to="/" class="close-detail position-absolute"></LocalizedLink>

        <arrow arrow-class="arrow-left" target="/safety-element"></arrow>
        <arrow arrow-class="arrow-right" target="/music"></arrow>

        <div class="product-copy-container">
          <transition name="bounce">
            <div v-if="show">
              <div class="product-title">
                <div class="product-num">1</div>
                <div class="product-name" v-html="$t('video_screen.title')"></div>
              </div>
              <div class="product-inst d-none d-sm-block" v-html="$t('video_screen.content.desktop')"></div>
              <div class="product-inst d-block d-sm-none" v-html="$t('video_screen.content.mobile')"></div>
            </div>
          </transition>
        </div>

      </div>
    </transition>
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterProduct"
        v-on:enter="actions.enterProduct"
        v-on:leave="actions.leaveProduct"
    >
      <div class="product-detail position-absolute">
        <Stars showStars="one" class="stars-container" />
        <Stars class="stars-container-two" />
        <div class="detail-inner">
          <div class="video-play" @click="setShowVideo(true)"><img :src="require('@/assets/imgs/playbutton.png')"></div>
          <img class="product-img" :src="require('@/assets/imgs/product-one/product.png')">
        </div>
      </div>
    </transition>
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterOverlayBg"
        v-on:enter="actions.enterOverlayBg"
        v-on:leave="actions.leaveVideoOverlayBg"
    >
      <div class="video-overlay" v-if="showVideo">

        <transition
            appear
            v-bind:css="false"
            v-on:before-enter="actions.beforeVideoModal"
            v-on:enter="actions.enterVideoModal"
            v-on:leave="actions.leaveVideoModal"
        >
          <div class="video-wrapper">
            <div @click="setShowVideo(false)" class="close-video position-absolute"></div>
            <youtube-iframe autoplay="1" :video-id="'ht3sqeBMczU'"></youtube-iframe>
          </div>
        </transition>
      </div>
    </transition>

  </div>
</template>

<script>
import Arrow from "../Arrow";
import LocalizedLink from '@/components/LocalizedLink'
import Stars from '@/components/particle/Stars.vue'

import {inject} from "vue";

export default {
  name: "VideoPage",
  components: {
    Arrow,
    LocalizedLink,
    Stars
  },
  data() {
    return {
      show: false,
      showVideo: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 800);
  },
  setup() {
    const store = inject("store");
    return {
      actions: store.actions
    };
  },
  methods: {
    setShowVideo(val) {
      console.log('setShowVideo', val);
      this.showVideo = val;
    }
  }

}
</script>

<style scoped lang="scss">
.product-detail {
  .detail-inner {
    .video-play {
      cursor: pointer;
      position: absolute;
      top: 42%;
      left: 43%;
      width: 6%;
      max-width: 75px;
      animation-name: button-pulse;
      animation-duration: 3s;
      animation-iteration-count: infinite;
      img {
        width: 100%;
      }
      @media screen and (min-width: 769px) and (max-width: 1024px) {
        left: auto;
        right: 4%;        
      }
      @media screen and (max-width: 768px) {
        left: auto;
        right: 11%;
        width: 9%;        
      }
    }    
  }

  @media screen and (max-width: 1024px) {
		width: 100vw;
		max-width: unset;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
		text-align: center;
		bottom: 0;
		top: auto !important;

    .detail-inner {
      position: relative;
      float: right;
      right: 40%;    

      .product-img {
        width: 200%;
        max-width: none;
      }
    }  
  }
}
.stars-container {
    position: absolute;
    top: 33%;
    left: 30%;    
    transform: scale(0.5);
    z-index: 1;
    @media screen and (max-width: 1024px) {
      top: 37vh;
      left: 8vw;
    }
    @media screen and (max-width: 414px) {
      top: 25vh;
      left: -3vw;
    }
}
.stars-container-two {
    position: absolute;
    top: 28%;
    left: 46%;    
    transform: rotate(200deg) scale(0.5);
    z-index: 1;
    @media screen and (max-width: 1024px) {
      top: 32vh;
      left: 54vw;
    }
    @media screen and (max-width: 414px) {
      top: 21vh;
      left: 50vw
    }
}

</style>
<style lang="scss">

.video-overlay {
  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.8;
  }

  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 20vh;

  @media (min-width: 1024px) {
    .video-wrapper {
      width: 63vw !important;
      margin: 0 auto !important;
      left: 0 !important;
      right: 0 !important;
    }
  }

  .video-wrapper {
    width: 98vw;
    position: relative;
    left: calc(50% - 2vw);
    right: calc(50% - 2vw);
    margin-left: -47vw;
    margin-right: -50vw;
    border: 5px solid #95c4de;
  }

  .vue-youtube-iframe {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
